export default __webpack_public_path__ + "static/media/2006.e87b9e88.png";